import { forwardRef } from 'react';
import clsx from 'clsx';

const FormInput = forwardRef(({ label, error, type = 'text', ...props }, ref) => {
  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <div className="mt-1">
        <input
          type={type}
          ref={ref}
          className={clsx(
            'appearance-none block w-full px-3 py-2 border rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-orrekie-500 focus:border-orrekie-500 sm:text-sm',
            error
              ? 'border-red-300 text-red-900 placeholder-red-300'
              : 'border-gray-300'
          )}
          {...props}
        />
      </div>
      {error && (
        <p className="mt-2 text-sm text-red-600" id={`${props.id}-error`}>
          {error}
        </p>
      )}
    </div>
  );
});

FormInput.displayName = 'FormInput';

export default FormInput; 